import { AuditLogs } from '../components/AuditLogs';

export function AdminAuditPage() {
  return <AuditLogs />;
}